import react from 'react'
import { ToDo, User, UserTeam, Team } from 'src/apiTypes'
import { useTranslation } from 'react-i18next'
import { IMAGE_API_ROOT } from 'src/request'

interface ItemProps {
  data: {
      team: UserTeam
      user: User
    type: string
    _id: string
    teamId: string
    
  }
  onClick?(): void
}
const Item = (props: ItemProps) => {
  const { t } = useTranslation(['common'])
  const { data, onClick } = props
  if (data.type === 'team') {
    return (
      <li className="todo-list-item" onClick={onClick}>
        <div className="todo-list-item-icon">
          <i className="icon-users"></i>
        </div>
        <div className="todo-list-item-info">
          <p className="todo-list-item-info-subtitle">
            {t('common:teamFeedback')}
          </p>
          <p className="todo-list-item-info-title">{data.team.name}</p>
        </div>
        <i className="icon-chevron-right"></i>
      </li>
    )
  }

  return (
    <li className="todo-list-item" onClick={onClick}>
        {data.user.profilePic ? 
      <img
        src={IMAGE_API_ROOT + data.user.profilePic}
        alt="User's profile picture"
        className="todo-list-item-img"
      />
      : <div className="todo-list-item-initials">{data.user.firstname[0] + data.user.lastname[0]}</div> }
      <div className="todo-list-item-info">
        <p className="todo-list-item-info-subtitle">
          {data.type} {t('common:feedback')}
        </p>
        <p className="todo-list-item-info-title">{data.user.firstname + ' ' + data.user.lastname}</p>
      </div>
      <i className="icon-chevron-right"></i>
    </li>
  )
}

interface Props {
  data?: ToDo[]
  selectUser(u: User | null): void
  selectTeam(u: UserTeam): void
}
const ToDoContainer = (props: Props) => {
  const { data, selectUser, selectTeam } = props
  return (
    <div className="todo">
      <ul className="todo-list">
        {data?.map((item) => (
          <Item
            key={item._id}
            onClick={() => {
              selectTeam(
                Object.assign({}, item.team, {
                  category: item.type,
                })
              )
              selectUser(item.target)
            }}
            data={{
              user: item.target,
                team: item.team ,
              type: item.type,
              teamId: item.team._id,
              _id: item._id
            }}
          />
        ))}
      </ul>
    </div>
  )
}
export default ToDoContainer
